// Package imports:
import React, { useEffect, useState } from 'react';
// Component imports:
import Alert from '../../../ui-elements/Alert/Alert';
import Loading from '../../../ui-elements/Loading/Loading';
import HeadSection from '../../../ui-elements/HeadSection/HeadSection';
import OverviewReportBody from './OverviewReportBody';
// Service imports:
import { GET_KELDAN_API_URL } from '../../../services/config';
import { ErrorMessages } from '../../../services/errorMessages';
// Type imports:
import { IEventReport, IKeldanApiResponse } from '../../../types/KeldanTypes';
import { IPropertySearchResult, IPropertyViewModel } from '../../../types/PropertyTypes';
import { Fetched } from '../../../types/Types';

const ViewOverview: React.FC<IPropertyViewModel> = ({
    eventId,
    bondsAllowed
}) => {
    const [report, setReport] = useState<Fetched<IEventReport<IPropertySearchResult>>>(null);

    const fetchReport = async () => {
        try {
            const url = `${GET_KELDAN_API_URL()}/Property/GetOverview/${eventId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            });
            if (response.ok) {
                if (response.redirected) {
                    window.location.href = response.url;
                }
                const responseBody: IKeldanApiResponse<IEventReport<IPropertySearchResult>> = await response.json();
                const { result, message } = responseBody;
                if (result) {
                    setReport(result);
                } else if (message) {
                    setReport(new Error(message));
                } else {
                    setReport(new Error(ErrorMessages.ErrorInRequest));
                }
            } else {
                setReport(new Error(ErrorMessages.RequestFailed));
            }
        } catch (e) {
            setReport(new Error(ErrorMessages.OtherShort));
        }
    }

    useEffect(() => {
        fetchReport();
    }, []);
    return (
        <div className='main KCL_property-page'>
            <div className='main__inner fluid'>
                <div className='shell'>
                    {report instanceof Error
                        ? <Alert type='error' headText={report.message} />
                        : report === undefined || report === null
                        ? <Loading />
                        : <>
                            <HeadSection title='Yfirlitsmynd' />
                            <OverviewReportBody report={report} bondsAllowed={bondsAllowed} />
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default ViewOverview;